import React, { useState, useRef } from 'react';
import {
    Button,
    ButtonGroup,
    ClickAwayListener,
    Grow,
    Paper,
    Popper,
    MenuItem,
    MenuList
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const customStyles = {
    buttonGroup: {
        boxShadow: 'none',
        borderRadius: '6px',
    },
    sendButton: {
        fontWeight: 500,
        padding: '5px 15px',
        flex: 1,
    },
    arrowButton: {
        padding: '5px 10px',
        minWidth: 'auto',
    },
    arrowIcon: (open) => ({
        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform 0.2s',
    }),
    paperMenu: {
        marginTop: '5px',
        minWidth: '220px',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.8)',
    },
    menuItem: {
        fontSize: '0.9rem',
        padding: '12px 16px',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#f0f0f0',
        }
    }
};

// Split button to save an aisle, either updating only the parent or also its children
export default function SaveSplitButton({ onSave, onSaveAndChangeLineals, loading, disabled }) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    /**
     * Handle special save action (parent + children update)
     * Closes menu and executes the callback
     */
    const handleSpecialSave = (event) => {
        handleClose(event);
        onSaveAndChangeLineals();
    };

    return (
        <>
            <ButtonGroup
                variant="contained"
                color="primary"
                ref={anchorRef}
                aria-label="split button"
                disabled={disabled || loading}
                style={customStyles.buttonGroup}
                disableElevation
            >
                {/* Main Save Button */}
                <Button
                    onClick={onSave}
                    sx={customStyles.sendButton}
                >
                    {loading ? "Saving..." : "SAVE"}
                </Button>

                <Button
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="menu"
                    onClick={handleToggle}
                    sx={customStyles.arrowButton}
                >
                    <KeyboardArrowDownIcon sx={customStyles.arrowIcon(open)} />
                </Button>
            </ButtonGroup>
            {/* Dropdown Menu Popper */}
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                style={{ zIndex: 1300 }}
                placement="bottom-end"
            >
                {({ TransitionProps }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: 'top right',
                        }}
                    >
                        <Paper sx={customStyles.paperMenu}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="split-button-menu" autoFocusItem={open}>
                                    <MenuItem
                                        onClick={handleSpecialSave}
                                        sx={customStyles.menuItem}
                                    >
                                        Save and Change Lineals
                                    </MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
}